import { NgModule } from '@angular/core';

import { FabButtonComponent } from './fab-button.component';

@NgModule({ declarations: [FabButtonComponent], exports: [FabButtonComponent] })
export class FabButtonModule {}

export { FabButtonComponent };
